<template>
  <div>
    <zoom-center-transition :duration="{ enter: 50, leave: 200 }" mode="out-in">
      <div v-if="selectedLink">
        <div class="row">
          <div class="col">
            <breadcrumb :transparent="true">
              <breadcrumb-item>
                <a href="#" @click.prevent="gotoDashboard()">Dashboard</a>
              </breadcrumb-item>
              <breadcrumb-item active>
                {{selectedLink.title}}
              </breadcrumb-item>
            </breadcrumb>
          </div>
        </div>
        <div ref="reportLinksContainer">
          <div class="row">
            <div class="col">
              <card>
                <div class="row"><div class="col text-center"><h4><b>{{ selectedLink.title }}</b></h4></div></div>
                <div class="row">
                  <div class="col">
                    <iframe :id="selectedLink.hspReportLinkId" :title="selectedLink.title" width="100%" :height="iframeHeight" :src="selectedLink.url" frameborder="0" allowFullScreen="true"></iframe>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
    </zoom-center-transition>
    <zoom-center-transition :duration="{ enter: 200, leave: 50 }" mode="out-in">
      <div v-if="!selectedLink" class="row">
        <div class="col-md-12 col-lg-12">
          <div class="card">
            <div class="card-header border-bottom">
              <h3 class="card-title">Dashboard</h3>
            </div>
            <div class="card-body">
              <div class="example">
                <div class="row mt-4">
                  <div v-for="item in reportLinks" :key="item.hspReportLinkId" class="col-md-12 col-xl-4">
                    <div class="thumbnail">
                      <a href="#" @click.prevent="openLink(item.hspReportLinkId)">
                        <img src="img/dashboard-thumb.png" :alt="`thumb${item.hspReportLinkId}`" class="thumbimg">
                      </a>
                      <div class="caption">
                        <h4>{{item.title}}</h4>
                        <p>
                          <button class="btn btn-primary my-1" @click="openLink(item.hspReportLinkId)">Open</button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </zoom-center-transition>
  </div>
</template>
<script>
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb.vue';
import BreadcrumbItem from 'src/components/Breadcrumb/BreadcrumbItem.vue';
import { ZoomCenterTransition } from 'vue2-transitions';
import { mapGetters } from 'vuex';
import * as reports from 'src/modules/surveyReports';
import { isNullOrEmpty } from 'src/modules/utils';

export default {
  name: 'Welcome',
  components: {
    Breadcrumb,
    BreadcrumbItem,
    ZoomCenterTransition,
  },
  data() {
    return {
      surveyUrlId: null,
      instance: null,
      selectedLink: null,
      reportLinks: [],
      aspectRatio: 1.6525,// 1.625,//2.07296,
      aspectRatioInverse: 1/1.6525, //0.61538461538461538461538461538462,// 0.4824016563147,
      iframeHeight: 760,
      iframeWidth: 0,
      referenceWidth: null,
      referenceHeight: null,
      lastReferenceWidth: 0,
      widthDeltaThreshold: 1,
      linksContainerResizeObserver: null,
      linksContainer: null,
    };
  },
  computed: {
    hasAvailableReports() {
      return this.reportLinks.length > 0;
    },
    hasValidAvailableReports() {
      return this.hasAvailableReports && this.reportLinks.filter(x => x.url.length > 0).length > 0;
    },
    surveyId() {
      return this.$route.params.surveyId;
    },
    urlId() {
      return this.$route.params.urlId;
    },
    isUser() {
      return this.adminUserIsUser;
    },
    ...mapGetters(['adminUser', 'adminUserRoles', 'instanceInfo', 'adminUserIsUser', 'getOrgSurveyById']),
  },
  methods: {
    updateReportLinks() {
      if (!this.hasAvailableReports) {
        return;
      }

      let count = 0;
      const srcRegex = /src=[^<]+?"/i;
      const titleRegex = /title=[^<]+?"/i;
      this.reportLinks.forEach(x => {
        count++;
        let regexMatch = null;
        let resultSplit = null;
        x.title = isNullOrEmpty(x.description) ? "Report " + count : x.description;
        if (isNullOrEmpty(x.url)) {
          if (!isNullOrEmpty(x.html)) {
            regexMatch = x.html.match(srcRegex);
            if (regexMatch.length > 0) {
              resultSplit = regexMatch[0].replace(/"/g, "").split("=");
              x.url = resultSplit[1];
            }
          }
        }

        // If there's no description, try to use the 'title' from the iframe tag of the html.
        if (isNullOrEmpty(x.description) && !isNullOrEmpty(x.html)) {
          // Find the "title" attribute and use it as the report title/label, if available.
          regexMatch = x.html.match(titleRegex);
          if (regexMatch.length > 0) {
            resultSplit = regexMatch[0].replace(/"/g, "").split("=");
            x.title = resultSplit[1];
          }
        }
      });
    },
    setIframeDimensions(newWidth, newHeight) {
      newWidth = newWidth || this.referenceWidth;
      this.iframeWidth = newWidth;

      newHeight = newHeight || newWidth * this.aspectRatioInverse;
      this.iframeHeight = newHeight;
    },
    initialize() {
      this.initializeRefLinksContainer();
    },
    /**
     * The $refs.reportLinksContainer <div> for displaying report links is initially undefined, 
     * therefore, define its set/get properties (bound to this.linksContainer) so we can 'watch' for when it gets created/destroyed, 
     * i.e., when the tag/component is available for use.
     */
    initializeRefLinksContainer() {
      Object.defineProperty(this.$refs, 'reportLinksContainer', {
        get: function () {
          return this.linksContainer;
        }.bind(this),
        set: function (newValue) {
          this.linksContainer = newValue;
        }.bind(this),
        enumerable: true
      });
    },
    initializeResizeObserver() {
      if (!this.linksContainerResizeObserver && this.$refs.reportLinksContainer) {
        this.linksContainerResizeObserver = new ResizeObserver((entries) => {
          let widthChangeTriggered = false;
          let newWidth = 0;
          let newHeight = 0;
          for (const entry of entries) {
            const { width, height } = entry.contentRect;
            if (Math.abs(width - this.lastReferenceWidth) < this.widthDeltaThreshold) {
              continue;
            }

            widthChangeTriggered = true;
            newWidth = width;
            newHeight = height;
          }

          if (widthChangeTriggered) {
            this.lastReferenceWidth = newWidth;
            this.referenceWidth = newWidth;
            this.referenceHeight = newHeight;
            const frameHeight = newWidth * this.aspectRatioInverse;
            this.setIframeDimensions(newWidth, frameHeight);
          }
        });

        this.linksContainerResizeObserver.observe(this.$refs.reportLinksContainer);
      }
    },
    disconnectResizeObserver() {
      if (this.linksContainerResizeObserver) {
        this.linksContainerResizeObserver.disconnect();
        this.linksContainerResizeObserver = null;
      }
    },
    getAvailableReports(reportRequest) {
      reportRequest = reportRequest || {
        surveyUrlId: this.urlId,
        hspSurveyId: this.surveyId
      };

      reports.getReportLinks(reportRequest)
        .then(data => {
          this.reportLinks = data.filter(x => 
            x.hspSurveyId === reportRequest.hspSurveyId || 
            (this.getOrgSurveyById(x.orgSurveyId) && this.getOrgSurveyById(x.orgSurveyId).surveyUrlId === reportRequest.surveyUrlId) ||
            (!x.hspSurveyId && !x.orgSurveyId)
          );

          if (isNullOrEmpty(this.reportLinks)) {
            return;
          }

          // filter by role(s) that have less permission
          if (this.isUser) {
            this.reportLinks = this.reportLinks.filter(x => !x.roleId || this.adminUserRoles.find(role => role.roleId === x.roleId));
          }

          if (this.reports && !this.reports.find(x => x.value === this.reportLinksKey)) {
            this.reports.push(this.reportLinksSel);
          }

          this.updateReportLinks();
        });
    },
    openLink(id) {
      this.selectedLink = this.reportLinks.find(x => x.hspReportLinkId === id);
    },
    gotoDashboard() {
      this.selectedLink = null;
    },
  },
  watch: {
    linksContainer: {
      handler(newValue, oldValue) {
        if (isNullOrEmpty(newValue)) {
          // Disconnect the observer when the component is no longer available (or destroyed).
          this.disconnectResizeObserver();
          return;
        }

        this.initializeResizeObserver();
      },
      deep: false,
      immediate: true
    },
  },
  mounted() {
    this.initialize();
    this.getAvailableReports();
  },
  beforeDestroy() {
    // Disconnect the observer when the component is destroyed.
    this.disconnectResizeObserver();
  },
};
</script>
